import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'integrations.searchSlackUsers.slackUserAsyncSelect.placeholder',
    defaultMessage: 'Search Slack users...',
  },
  loadErrorTitle: {
    id: 'integrations.searchSlackUsers.slackUserAsyncSelect.loadErrorTitle',
    defaultMessage: 'Error',
  },
  loadErrorMessage: {
    id: 'integrations.searchSlackUsers.slackUserAsyncSelect.loadErrorMessage',
    defaultMessage: 'Failed to load Slack users. Please try again.',
  },
})
